import React, { useEffect, useState } from "react";
import _ from "lodash";
import moment from "moment-timezone";
import ContentWrapper from "../../Wrapper";
import { useDispatch, useSelector } from "react-redux";
import { getCampaignLiveStatusRequest } from "../store/actions/campaign-live-status.actions";
import SummaryReportFilter from "../components/summary-report-filter";
import { campaignOptionObj } from "../constants";
import { ContentLoadingWithoutCard } from "../../../components/loading";
import { CustomSubHeader } from "../../../components/subheader";
import AdvanceDataTable from "../../../components/normal-table/advance-table";
import { CustomEmptyPage } from "../../../components/empty_page/custom-empty-page";

const columns = {
  email: [
    { title: "Company Name", apiKeyName: "companyName", fieldInputType: "INPUT" },
    { title: "User Name", apiKeyName: "fullName", fieldInputType: "INPUT" },
    { title: "User Email", apiKeyName: "email", fieldInputType: "INPUT" },

    { title: "Total Sent", apiKeyName: "sent", fieldInputType: "INPUT" },
    { title: "Opened", apiKeyName: "opened", fieldInputType: "INPUT" },
    { title: "Clicked", apiKeyName: "clicked", fieldInputType: "INPUT" },
    { title: "Bounce", apiKeyName: "bounce", fieldInputType: "INPUT" },
    { title: "Complaint", apiKeyName: "complaint", fieldInputType: "INPUT" },
    { title: "Unsubscribed", apiKeyName: "unsubscribed", fieldInputType: "INPUT" },
    { title: "Failed", apiKeyName: "failed", fieldInputType: "INPUT" },
    { title: "Cost", apiKeyName: "cost", fieldInputType: "INPUT" },

    { title: "Currency", apiKeyName: "currency", fieldInputType: "INPUT" },
    { title: "Timezone", apiKeyName: "timezone", fieldInputType: "INPUT" },
  ],
  sms: [
    { title: "Company Name", apiKeyName: "companyName", fieldInputType: "INPUT" },
    { title: "User Name", apiKeyName: "fullName", fieldInputType: "INPUT" },
    { title: "User Email", apiKeyName: "email", fieldInputType: "INPUT" },

    { title: "Total Audience", apiKeyName: "sent", fieldInputType: "INPUT" },
    { title: "Total SMS Sent", apiKeyName: "smsSent", fieldInputType: "INPUT" },
    { title: "Delivered", apiKeyName: "smsDelivered", fieldInputType: "INPUT" },
    { title: "Submitted", apiKeyName: "smsSubmitted", fieldInputType: "INPUT" },
    { title: "Undelivered", apiKeyName: "smsUndelivered", fieldInputType: "INPUT" },
    { title: "Cost", apiKeyName: "cost", fieldInputType: "INPUT" },

    { title: "Currency", apiKeyName: "currency", fieldInputType: "INPUT" },
    { title: "Timezone", apiKeyName: "timezone", fieldInputType: "INPUT" },
  ],
  whatsapp: [
    { title: "Company Name", apiKeyName: "companyName", fieldInputType: "INPUT" },
    { title: "User Name", apiKeyName: "fullName", fieldInputType: "INPUT" },
    { title: "User Email", apiKeyName: "email", fieldInputType: "INPUT" },

    { title: "Total Sent", apiKeyName: "sent", fieldInputType: "INPUT" },
    { title: "Delivered", apiKeyName: "delivered", fieldInputType: "INPUT" },
    { title: "Failed", apiKeyName: "failed", fieldInputType: "INPUT" },
    { title: "Read", apiKeyName: "read", fieldInputType: "INPUT" },
    { title: "Deleted", apiKeyName: "deleted", fieldInputType: "INPUT" },
    { title: "Cost", apiKeyName: "cost", fieldInputType: "INPUT" },

    { title: "Currency", apiKeyName: "currency", fieldInputType: "INPUT" },
    { title: "Timezone", apiKeyName: "timezone", fieldInputType: "INPUT" },
  ],
  rcs: [
    { title: "Company Name", apiKeyName: "companyName", fieldInputType: "INPUT" },
    { title: "User Name", apiKeyName: "fullName", fieldInputType: "INPUT" },
    { title: "User Email", apiKeyName: "email", fieldInputType: "INPUT" },

    { title: "Total Sent", apiKeyName: "sent", fieldInputType: "INPUT" },
    { title: "Delivered", apiKeyName: "delivered", fieldInputType: "INPUT" },
    { title: "Failed", apiKeyName: "failed", fieldInputType: "INPUT" },
    { title: "Read", apiKeyName: "read", fieldInputType: "INPUT" },
    { title: "Cost", apiKeyName: "cost", fieldInputType: "INPUT" },

    { title: "Currency", apiKeyName: "currency", fieldInputType: "INPUT" },
    { title: "Timezone", apiKeyName: "timezone", fieldInputType: "INPUT" },
  ]
}
export default function CampaignLiveStatus(props) {
  const [show, setShow] = useState(false);
  const [limit, setLimit] = useState(15);
  const [pageNo, setPageNo] = useState(1);
  const [channel, setChannel] = useState("sms");
  const [type, setType] = useState("all");
  const [updatedData, setUpdatedData] = useState([]);
  const [fromDate, setFromDate] = useState(moment().startOf("days").valueOf());
  const [toDate, setToDate] = useState(moment().add(1, "day").endOf("day").valueOf());
  const [search, setSearch] = useState("");
  const [initalFilterValue, setInitialFilterValue] = useState({
    type: "all",
    fromDate: moment().startOf("days").valueOf(),
    toDate: moment().add(1, "day").endOf("day").valueOf(),
  });
  const links = [
    { name: "SMS Live Status", channel: "sms" },
    { name: "Email Live Status", channel: "email" },
    { name: "Whatsapp Live Status", channel: "whatsapp" },
    { name: "RCS Live Status", channel: "rcs" },
  ];

  const dispatch = useDispatch();

  const emailSummaryReportStore = useSelector((store) => store.campaignLiveStatusV2);

  useEffect(() => {
    if (fromDate && toDate) {
      dispatch(getCampaignLiveStatusRequest({ startDate: fromDate, endDate: toDate, channel: channel, type: type, search: search || "" }));
    }
  }, [dispatch, fromDate, toDate, channel, type, search]);

  useEffect(() => {
    if (!_.isEmpty(emailSummaryReportStore.data)) {
      const options = [],
        total = {
          sent: 0,
          opened: 0,
          clicked: 0,
          bounce: 0,
          complaint: 0,
          unsubscribed: 0,
          total: 0,
          failed: 0,
          cost: 0,
          smsSent: 0,
          smsSent2: 0,
          smsDelivered: 0,
          smsSubmitted: 0,
          smsUndelivered: 0,
          delivered: 0,
          read: 0,
          deleted: 0
        };
      emailSummaryReportStore.data.map((each) => ({ ...each, smsSent2: each.smsSent })).forEach((each) => {
        options.push(each);
        for (let key in each) {
          if (total.hasOwnProperty(key)) {
            total[key] = _.round(total[key] + each[key], 4);
          }
          if (
            key === "opened" ||
            key === "clicked" ||
            key === "bounce" ||
            key === "complaint" ||
            key === "unsubscribed" || key === "delivered" || key === "read" || key === "deleted" || key === "failed"
          ) {
            each[key] = `${each[key]} (${Math.round((each[key] / each.sent) * 100)}%)`;
          }
          else if (key === "smsSent" ||
            key === "smsDelivered" ||
            key === "smsSubmitted" ||
            key === "smsUndelivered") {
            each[key] = `${each[key]} (${Math.round((each[key] / each.smsSent2) * 100)}%)`;
          }
        }
      });
      for (let key in total) {
        if (
          key === "opened" ||
          key === "clicked" ||
          key === "bounce" ||
          key === "complaint" ||
          key === "unsubscribed" || key === "delivered" || key === "read" || key === "deleted" || key === "failed"
        ) {
          total[key] = `${total[key]} (${Math.round((total[key] / total.sent) * 100)}%)`;
        }
        else if (key === "smsSent" ||
          key === "smsDelivered" ||
          key === "smsSubmitted" ||
          key === "smsUndelivered") {
          total[key] = `${total[key]} (${Math.round((total[key] / total.smsSent2) * 100)}%)`;
        }
      }
      options.push(total);
      setUpdatedData(options);
    }
    else {
      setUpdatedData([]);
    }
  }, [emailSummaryReportStore.data]);

  const handleApplyFilter = (data) => {
    setType(data.type);
    setFromDate(data.fromDate);
    setToDate(data.toDate);
    setShow(false);
    setPageNo(1);
    setLimit(15);
    setInitialFilterValue(data);
    setSearch(data.search || "");
  };

  const handleCancelFilter = () => {
    setShow(false);
  };

  return (
    <ContentWrapper
      subHeader={
        <CustomSubHeader>
          <div className="d-flex flex-stack w-100">
            <div className="menu menu-xs-rounded menu-xs-row menu-state-bg menu-title-gray-700 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-400 fw-bold my-5 my-lg-0 align-items-stretch">
              {links.map((link, index) => (
                <div key={index} className="menu-item me-lg-1">
                  <div className={`menu-link py-3 ${channel === link.channel ? "active" : ""}`} onClick={() => setChannel(link.channel)}>
                    <span className="menu-title">{link.name}</span>
                  </div>
                </div>
              ))}
            </div>
            <div> <div className="d-flex gap-3 align-items-center">
              {type && <div className="badge badge-light-primary fs-7">{campaignOptionObj[type]}</div>}
              {fromDate && toDate && (
                <div className="badge badge-light-primary fs-7">
                  {moment(fromDate).format("MMM DD")}
                  {" - "}
                  {moment(toDate).format("MMM DD")}
                </div>
              )}
              {search && <div className="badge badge-light-primary fs-7">{search}</div>}
              <SummaryReportFilter show={show} setShow={setShow} filterValue={initalFilterValue} handleApplyFilter={handleApplyFilter} handleCancelFilter={handleCancelFilter} />
            </div></div>
          </div>
        </CustomSubHeader>

      }
    >
      {emailSummaryReportStore.loading ? (
        <ContentLoadingWithoutCard />
      ) : updatedData.length === 0 ? (
        <CustomEmptyPage page="no-report" />
      ) : (
        <div className={`card card-custom`}>
          <div className="card-body py-3 px-3" style={{ padding: 15 }}>
            <AdvanceDataTable
              columns={columns[channel]}
              data={updatedData}
              limit={limit}
              pageNo={pageNo}
              setLimit={setLimit}
              setPageNo={setPageNo}
              count={emailSummaryReportStore.data.length}
            />
          </div>
        </div>
      )}
    </ContentWrapper>
  );
}
